import BaseModule from "./BaseModule";

class Module extends BaseModule {

}

const AddPropertyModule = new Module();
export default AddPropertyModule;
